import { Control } from "ol/control";

class Impresion extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const tipLabel = options.tipLabel ? options.tipLabel : "Toggle full-screen";

    const button = document.createElement("button");
    button.title = tipLabel;
    button.innerText = "";
    const element = document.createElement("div");
    element.className = "impresion ol-unselectable ol-control";
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    this.impresionDialog = document.getElementById("dialog-impresion");
    let cancelDialog = document.getElementById("cancel");

    button.addEventListener("click", this.handleOpenDialog.bind(this), false);

    cancelDialog.addEventListener("click", () => {
      this.handleCloseDialog();
    });
  }

  handleCloseDialog() {
    this.impresionDialog.close();
  }

  handleOpenDialog() {
    this.impresionDialog.showModal();
  }
}

export default Impresion;
